import React from 'react';
import { styled } from '@nykaa/ui-components';

import CheckBox from '../Shared/CheckBox';
import { MultiFilters } from '../types';


const Wrapper = styled.div`
  width: 100%;
`;


const MultiSelect = (props: MultiFilters) => {
  const {
    filterData,
    handleFilterChange,
    activeFilters,
  } = props;
  const { data = [] } = filterData || {};

  return (
    <Wrapper>
      {
        data?.map(item => {
          const isSelected = (Array.isArray(activeFilters) && activeFilters.some(filter => filter.id == item.id));
          return (
            <CheckBox type = "checkbox" isSelected={isSelected} handleFilterChange={handleFilterChange} key={`chk_${item.id}`} data={item} />
          );
        })
      }
    </Wrapper>
  );
};

export default MultiSelect;
